/* eslint-disable max-len */
export default {
  title_pc: '用设计和技术为用户带来极致体验',
  title_sp: '用设计和技术为用户带来极致体验',
  description1_pc: '飞狼是一家以中国为据点，\n坚持以用户为中心的设计和技术服务的专业团队。',
  description1_sp: '飞狼是一家以中国为据点，\n坚持以用户为中心的设计和技术\n服务的专业团队。',
  description2: '源于中国，放眼全球。\n以最前沿的IT技术解决需求，\n我们将是您全新体验的最佳伙伴。',
};
